import { useMutation, useQueryClient } from '@tanstack/react-query';
import { taskCategoryService } from '@services/taskCategory';
import {
  TaskCategory,
  TaskCategoryCreateInput,
  TaskCategoryUpdateInput,
} from '@models/taskCategory.model';
import {
  ACTIVE_TASK_CATEGORIES_QUERY_KEY,
  TASK_CATEGORIES_QUERY_KEY,
} from './useTaskCategories';

const invalidateAll = (queryClient: ReturnType<typeof useQueryClient>) => {
  queryClient.invalidateQueries({ queryKey: TASK_CATEGORIES_QUERY_KEY });
  queryClient.invalidateQueries({ queryKey: ACTIVE_TASK_CATEGORIES_QUERY_KEY });
};

export const useCreateTaskCategory = () => {
  const queryClient = useQueryClient();
  return useMutation<TaskCategory, Error, TaskCategoryCreateInput>({
    mutationFn: (input) => taskCategoryService.createTaskCategory(input),
    onSuccess: () => invalidateAll(queryClient),
  });
};

export const useUpdateTaskCategory = () => {
  const queryClient = useQueryClient();
  return useMutation<TaskCategory, Error, TaskCategoryUpdateInput>({
    mutationFn: (input) => taskCategoryService.updateTaskCategory(input),
    onSuccess: () => invalidateAll(queryClient),
  });
};

export const useDeleteTaskCategory = () => {
  const queryClient = useQueryClient();
  return useMutation<{ affected: number }, Error, string>({
    mutationFn: (taskCategoryId) => taskCategoryService.deleteTaskCategory(taskCategoryId),
    onSuccess: () => invalidateAll(queryClient),
  });
};
